import {memo} from 'react';

import styled from 'styled-components';
import {useSelector} from 'react-redux';

import BurgerMenuIcon from '~/assets/images/icons/burger-menu.svg?react';
import {getLocalizationService} from '~/shared/services/localisationService';
import {selectUserData} from '~/shared/store/selectors';
import {body14Normal} from '~/shared/theme/typography';
import ChevronDown from '~/assets/images/icons/chevron-down.svg?react';
import {media} from '~/shared/theme/media';
import {flexCenter} from '~/shared/theme/FlexLayout';

import PageHeaderActionMenu from './PageHeaderActionMenu';

const StyledBurgerMenu = styled(PageHeaderActionMenu)`
  width: 20px;
  height: 20px;
  justify-content: center;

  img {
    margin: 0;
    width: 20px;
    height: 20px;
  }
`;

export const StyledArrow = styled(ChevronDown)`
  transform: rotate3d(0, 0, 1, ${({$isOpen}) => ($isOpen ? 180 : 0)}deg);
`;

const StyledTextMenuButton = styled(PageHeaderActionMenu)`
  position: relative;
`;

const OpenMenuContent = styled.div`
  display: flex;
  color: ${({theme}) => theme.colors.charcoal80};
  ${body14Normal}
  column-gap: 4px;
  align-items: center;
`;

const UserName = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 116px;
  ${media.minLargeTablet`
    max-width: 279px;
  `}
  ${media.minLargeDesktop`
    max-width: 503px;
  `}
`;

const UserMenuButton = ({isOpen}: {isOpen?: boolean}) => {
  const userData = useSelector(selectUserData);
  const {t} = getLocalizationService();

  return (
    <OpenMenuContent>
      <UserName>
        {t('hi_xxx', {name: userData?.firstName})}
      </UserName>
      <StyledArrow $isOpen={isOpen} />
    </OpenMenuContent>
  );
};

const BurgerMenuWrapper = styled.div`
  ${flexCenter}
  padding: 1px;
`;

const BurgerMenu = () => {
  return (
    <BurgerMenuWrapper>
      <BurgerMenuIcon />
    </BurgerMenuWrapper>
  );
};

const UserMenu = ({isMinLargeMobile}: {
  isMinLargeMobile: boolean;
}) => {

  if (isMinLargeMobile) {
    return (
      // @ts-expect-error non ts.
      <StyledTextMenuButton burgerMenu CustomMenuComponent={UserMenuButton}/>
    );
  }

  return (
    <StyledBurgerMenu
      burgerMenu
      // @ts-expect-error non ts.
      CustomMenuComponent={BurgerMenu}
    />
  );
};

export default memo(UserMenu);
